import React from 'react';
import c from 'classnames';
import TextAreaInputField, { TextAreaInputFieldProps } from '../TextAreaInputField';
import s from './LimitedTextAreaInputField.scss';

export interface Props extends TextAreaInputFieldProps {
  value?: string;
  maxLength: number;
  showCounter?: boolean;
}

/**
 * One of our standard, plaintext `<textarea />`s.
 *
 * Limits input to a a specified length (`max`) and displays the remaining character allowance in the bottom right of the input.
 */
const LimitedTextAreaInputField = React.forwardRef<HTMLTextAreaElement, Props>(
  ({ maxLength, value, className, showCounter = true, ...rest }, ref) => {
    return (
      <div className={s['root']}>
        <TextAreaInputField
          maxLength={maxLength}
          value={value}
          className={c(s['textarea'], className)}
          ref={ref}
          {...rest}
        />
        {showCounter && (
          <span className={s['remaining-length']}>{maxLength - (value?.length ?? 0)}</span>
        )}
      </div>
    );
  }
);
LimitedTextAreaInputField.displayName = 'LimitedTextAreaInputField';

export default LimitedTextAreaInputField;
